// @ts-check

import BaseModel from "@kaspernj/api-maker/build/base-model.js"
import Collection from "@kaspernj/api-maker/build/collection.js"
import FeedbackAssignment from "./feedback-assignment.js"
import FeedbackStep from "./feedback-step.js"
import TeamSurvey from "./team-survey.js"

const modelClassData = {
  "attributes": {
    "id": {
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      },
      "name": "id",
      "selected_by_default": null,
      "translated": null
    },
    "state": {
      "column": {
        "default": "new",
        "name": "state",
        "null": true,
        "type": "string"
      },
      "name": "state",
      "selected_by_default": null,
      "translated": null
    },
    "translated_state": {
      "column": null,
      "name": "translated_state",
      "selected_by_default": null,
      "translated": null
    }
  },
  "className": "FeedbackSurvey",
  "collectionKey": "feedback_surveys",
  "collectionName": "feedback_surveys",
  "i18nKey": "feedback_survey",
  "camelizedLower": "feedbackSurvey",
  "name": "FeedbackSurvey",
  "nameDasherized": "feedback-survey",
  "pluralName": "feedback_surveys",
  "ransackable_associations": [
    {
      "className": "Competition",
      "collectionName": "competitions",
      "foreignKey": "competition_id",
      "name": "competition",
      "macro": "has_one",
      "resource_name": "Competition",
      "through": "feedback_assignment"
    },
    {
      "className": "FeedbackAssignment",
      "collectionName": "feedback_assignments",
      "foreignKey": "feedback_assignment_id",
      "name": "feedback_assignment",
      "macro": "belongs_to",
      "resource_name": "FeedbackAssignment",
      "through": null
    },
    {
      "className": "FeedbackStep",
      "collectionName": "feedback_steps",
      "foreignKey": "feedback_survey_id",
      "name": "feedback_steps",
      "macro": "has_many",
      "resource_name": "FeedbackStep",
      "through": null
    },
    {
      "className": "Log",
      "collectionName": "logs",
      "foreignKey": "trackable_id",
      "name": "logs",
      "macro": "has_many",
      "resource_name": "Log",
      "through": null
    },
    {
      "className": "FeedbackStep",
      "collectionName": "feedback_steps",
      "foreignKey": "feedback_survey_id",
      "name": "next_feedback_step",
      "macro": "has_one",
      "resource_name": "FeedbackStep",
      "through": null
    },
    {
      "className": "Survey",
      "collectionName": "surveys",
      "foreignKey": "survey_id",
      "name": "survey",
      "macro": "has_one",
      "resource_name": "Survey",
      "through": "feedback_assignment"
    },
    {
      "className": "Tagging",
      "collectionName": "taggings",
      "foreignKey": "resource_id",
      "name": "taggings",
      "macro": "has_many",
      "resource_name": "Tagging",
      "through": null
    },
    {
      "className": "Tag",
      "collectionName": "tags",
      "foreignKey": "tag_id",
      "name": "tags",
      "macro": "has_many",
      "resource_name": "Tag",
      "through": "taggings"
    },
    {
      "className": "TeamSurvey",
      "collectionName": "team_surveys",
      "foreignKey": "team_survey_to_feedback_id",
      "name": "team_survey_to_feedback",
      "macro": "has_one",
      "resource_name": "TeamSurvey",
      "through": "feedback_assignment"
    },
    {
      "className": "Tenant",
      "collectionName": "tenants",
      "foreignKey": "tenant_id",
      "name": "tenant",
      "macro": "belongs_to",
      "resource_name": "Tenant",
      "through": null
    },
    {
      "className": "WorkerPlugins::WorkplaceLink",
      "collectionName": "workplace_links",
      "foreignKey": "resource_id",
      "name": "workplace_links",
      "macro": "has_many",
      "resource_name": "WorkplaceLink",
      "through": null
    }
  ],
  "ransackable_attributes": [
    {
      "name": "created_at",
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "feedback_assignment_id",
      "column": {
        "default": null,
        "name": "feedback_assignment_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "id",
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "id_string",
      "column": null
    },
    {
      "name": "old_feedback_assignment_id",
      "column": {
        "default": null,
        "name": "old_feedback_assignment_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "old_id",
      "column": {
        "default": null,
        "name": "old_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "state",
      "column": {
        "default": "new",
        "name": "state",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "tenant_id",
      "column": {
        "default": null,
        "name": "tenant_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "updated_at",
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      }
    }
  ],
  "ransackable_scopes": [
    {
      "name": "in_current_workplace"
    },
    {
      "name": "soft_deleted_filter"
    },
    {
      "name": "sort_by_in_current_workplace_asc"
    },
    {
      "name": "sort_by_in_current_workplace_desc"
    }
  ],
  "relationships": [
    {
      "className": "FeedbackAssignment",
      "collectionName": "feedback_assignments",
      "foreignKey": "feedback_assignment_id",
      "name": "feedback_assignment",
      "macro": "belongs_to",
      "resource_name": "FeedbackAssignment",
      "through": null
    },
    {
      "className": "FeedbackStep",
      "collectionName": "feedback_steps",
      "foreignKey": "feedback_survey_id",
      "name": "feedback_steps",
      "macro": "has_many",
      "resource_name": "FeedbackStep",
      "through": null
    },
    {
      "className": "FeedbackStep",
      "collectionName": "feedback_steps",
      "foreignKey": "feedback_survey_id",
      "name": "next_feedback_step",
      "macro": "has_one",
      "resource_name": "FeedbackStep",
      "through": null
    },
    {
      "className": "TeamSurvey",
      "collectionName": "team_surveys",
      "foreignKey": "team_survey_to_feedback_id",
      "name": "team_survey_to_feedback",
      "macro": "has_one",
      "resource_name": "TeamSurvey",
      "through": "feedback_assignment"
    }
  ],
  "paramKey": "feedback_survey",
  "primaryKey": "id"
}

/** Frontend model for FeedbackSurvey. */
export default class FeedbackSurvey extends BaseModel {
  /** @returns {typeof modelClassData} */
  static modelClassData() {
    return modelClassData
  }

  /** @returns {string} */
  id() {
    return this.readAttributeUnderscore("id")
  }

  /** @returns {boolean} */
  hasId() {
    const value = this.id()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  state() {
    return this.readAttributeUnderscore("state")
  }

  /** @returns {boolean} */
  hasState() {
    const value = this.state()

    return this._isPresent(value)
  }

  /** @returns {any} */
  translatedState() {
    return this.readAttributeUnderscore("translated_state")
  }

  /** @returns {boolean} */
  hasTranslatedState() {
    const value = this.translatedState()

    return this._isPresent(value)
  }

  /** @returns {import("./feedback-assignment.js").default | null} */
  feedbackAssignment() {
    return this._readBelongsToReflection({modelClass: FeedbackAssignment, reflectionName: "feedback_assignment"})
  }

  /** @returns {Promise<import("./feedback-assignment.js").default | null>} */
  loadFeedbackAssignment() {
    if (!("feedbackAssignmentId" in this)) throw new Error("Foreign key method wasn't defined: feedbackAssignmentId")

    const id = this.feedbackAssignmentId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "feedback_assignment",
        model: this,
        modelClass: FeedbackAssignment
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./feedback-assignment.js").default | null>} */
  ensureFeedbackAssignmentLoaded() {
    return this.ensureAssociationLoaded("feedback_assignment")
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./feedback-step.js").default>} */
  feedbackSteps() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const ransack = {}

    ransack["feedback_survey_id_eq"] = this.id()

    return new Collection(
      {
        reflectionName: "feedback_steps",
        model: this,
        modelClass: FeedbackStep
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./feedback-step.js").default>>} */
  loadFeedbackSteps() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const ransack = {}

    ransack["feedback_survey_id_eq"] = this.id()

    return this._loadHasManyReflection(
      {
        reflectionName: "feedback_steps",
        model: this,
        modelClass: FeedbackStep
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./feedback-step.js").default>>} */
  ensureFeedbackStepsLoaded() {
    return this.ensureAssociationLoaded("feedback_steps")
  }

  /** @returns {import("./feedback-step.js").default | null} */
  nextFeedbackStep() {
    return this._readHasOneReflection({modelClass: FeedbackStep, reflectionName: "next_feedback_step"})
  }

  /** @returns {Promise<import("./feedback-step.js").default | null>} */
  loadNextFeedbackStep() {
    if (!("id" in this)) throw new Error("Primary key method wasn't defined: id")

    const id = this.id()
    const ransack = {}

    ransack["feedback_survey_id_eq"] = id

    return this._loadHasOneReflection(
      {
        reflectionName: "next_feedback_step",
        model: this,
        modelClass: FeedbackStep
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./feedback-step.js").default | null>} */
  ensureNextFeedbackStepLoaded() {
    return this.ensureAssociationLoaded("next_feedback_step")
  }

  /** @returns {import("./team-survey.js").default | null} */
  teamSurveyToFeedback() {
    return this._readHasOneReflection({modelClass: TeamSurvey, reflectionName: "team_survey_to_feedback"})
  }

  /** @returns {Promise<import("./team-survey.js").default | null>} */
  loadTeamSurveyToFeedback() {
    if (!("id" in this)) throw new Error("Primary key method wasn't defined: id")

    const id = this.id()

    return this._loadHasOneReflection(
      {
        reflectionName: "team_survey_to_feedback",
        model: this,
        modelClass: TeamSurvey
      },
      {
        params: {
          through: {
            model: "FeedbackSurvey",
            id,
            reflection: "team_survey_to_feedback"
          }
        }
      }
    )
  }

  /** @returns {Promise<import("./team-survey.js").default | null>} */
  ensureTeamSurveyToFeedbackLoaded() {
    return this.ensureAssociationLoaded("team_survey_to_feedback")
  }
}
